import { CustomerTableConstant } from "./customerTableConstant";


const customerTableActions = {};

customerTableActions.getCustomerTable = ({ vendor_id, model_id, station_id, manufacturer_id }) => ({
    type: CustomerTableConstant.CUSTOMER_TABLE_SAGA,
    payload: {
        vendor_id: vendor_id,
        model_id: model_id,
        station_id: station_id,
        manufacturer_id: manufacturer_id
    }
});



export { customerTableActions };
